module.exports = __webpack_public_path__ + "img/0Q3B2213_WoodMatted.1f014e6b.jpg";